import http from "../http";
import Service from "../../Service";

export default class AnnouncementsService extends Service {
    list() {
        return http.get("announcements", { headers: this.getHeaders() });
    }

    pending() {
        return http.get("announcements/pending", { headers: this.getHeaders() });
    }

    seen(id) {
        return http.post(`announcements/${id}/seen`, null, {
            headers: this.getHeaders(),
        });
    }
}
